import React from 'react'
import { connect } from 'react-redux'
import LeftMenu from '../LeftMenu'
import General from '../RightMenu/General'
import { withStyles } from '@material-ui/core'

const styles = (theme) => ({
	main: {
		height: '100%',
		[theme.breakpoints.down('xs')]: {
			padding: '64px 12px 54px',
			width: '100vw',
		},
	},
})

const Mobile = ({ campaignID, pastFirstPage, classes }) => (
	<div className={classes.main}>
		{pastFirstPage ? (
			<LeftMenu mobile campaignID={campaignID} />
		) : (
			<div
				style={{
					backgroundColor: 'white',
					borderRadius: 35,
					border: '1px solid gray',
					padding: 20,
				}}
			>
				<General />
			</div>
		)}
	</div>
)

export default connect(
	(state) => ({ pastFirstPage: state.view.stepper.campaign > 0 }),
	null,
)(withStyles(styles)(Mobile))
